import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const createRechargeOrderV2 = createAsyncThunk(
  'CoinAgencyWallet/createRechargeOrderV2',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        ...params,
        recharge_type: 1,
      },
      {
        xcErrorToast: !params?.xcErrorToast,
      }
    )
    return resp.data
  }
)

export const getRAProductsList = createAsyncThunk(
  'CoinAgencyWallet/getRAProductsList',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_products_list_h5_v2', {
      ...store.getState().env.deviceinfo,
      ...params,
    })
    return resp.data
  }
)
type initialStateType = {
  countries: {code: number; name: string}[]
  default_country: {code: number; name: string}
  list: any[]
}
const initialState: initialStateType = {
  countries: [],
  default_country: {} as any,
  list: [],
}

export const AgencyRecharge = createSlice({
  name: 'Animal_Finch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRAProductsList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export default AgencyRecharge.reducer
